<div *ngIf="showTable && parts?.length > 0" class="px-2">
  <div class="table-responsive">
    <table class="table table-inverse">
      <thead>
      <tr>
        <th>{{'doctrine.part.name'|translate}}</th>
        <th>{{'doctrine.part.code'|translate}}</th>
        <th [ngStyle]="{'width.rem': '6'}">{{'doctrine.part.amount'|translate}}</th>
        <th [ngStyle]="{'width.rem': '15'}" *ngIf="multipliers.length > 0">{{'doctrine.option.price_multiplier'|translate}}</th>
        <th [ngStyle]="{'width.rem': '10'}" class="text-end">{{'global.actions'|translate}}</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let item of parts; let i=index">
        <tr>
          <td>{{item.part.name}}</td>
          <td>{{item.part.code}}</td>
          <td [ngStyle]="{'width.rem': '6'}">
            <input type="number" 
                   [id]="'partAmount'+i" 
                   [name]="'partAmount'+i" 
                   [(ngModel)]="item.amount"
                   min="1"
                   class="form-control" 
                   (blur)="onAmountChange(i, $event)"
                   [disabled]="isUpdating"
                   required>
          </td>
          <td [ngStyle]="{'width.rem': '15', 'line-height': '1.5'}" *ngIf="multipliers.length > 0">
            <ng-select class="ng-select" 
                       [id]="'partMultiplier'+i" 
                       [name]="'partMultiplier'+i" 
                       [ngModel]="item.property ? item.property.id : null"
                       (change)="onMultiplierChange(i, $event)"
                       [disabled]="isUpdating"
                       appendTo=".card-block"
                       [clearable]="true"
                       [placeholder]="'global.select'|translate">
              <ng-option [value]="multiplier.id" 
                         *ngFor="let multiplier of multipliers">{{multiplier.name}}</ng-option>
            </ng-select>
          </td>
          <td [ngStyle]="{'width.rem': '10'}" class="text-end">
            <button type="button" 
                    class="btn btn-lg btn-primary btn-icon ripple light ms-1 btn-action"
                    (click)="onRemovePart(i)">
              <i class="fa fa-close"></i>
            </button>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
</div> 